import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import userRoutes from '../../../components/user/userRoutes';
import authenticate from './authenticate';

const logout = createAsyncThunk(
  'thunk/user/login/uuid',
  async (arg, thunkAPI) => {
    const response = await apiFetch(userRoutes.api.loginWithUUID, {
      body: arg?.data,
      method: 'POST',
    });
    thunkAPI.dispatch(authenticate());
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default logout;
